import styled from "styled-components";

export const LoginContainer = styled.div`
  max-width: 496px;
  width: 100%;
`;

export const Title = styled.h1`
  color: #202124;
  font-family: "Noto Sans", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 140%;
  margin: 0 0 24px;
  text-align: center;
`;

export const MessageTitle = styled(Title)`
  margin-bottom: 8px;
`;

export const MessageText = styled.p`
  color: #383839;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 140%;
  margin: 0;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Label = styled.label`
  color: #202124;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
`;

export const Required = styled.span`
  color: #e12d39;
`;

export const Input = styled.input`
  border: 1px solid #b8bbc1;
  border-radius: 4px;
  color: #202124;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  height: 40px;
  line-height: 140%;
  padding: 8px 16px;
  width: 100%;

  &:focus {
    border-color: #01ab7d;
    outline: none;
  }
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PasswordInput = styled(Input)`
  padding-right: 44px;
`;

export const TogglePasswordButton = styled.button.attrs({ type: "button" })`
  align-items: center;
  background: transparent;
  border: 0;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
`;

export const Button = styled.button`
  align-items: center;
  background: #01bf86;
  border: 0;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  margin-top: 8px;
  width: 100%;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:hover:not(:disabled) {
    background: #009f70;
  }
`;

export const InlineLink = styled.a`
  color: #009f70;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    color: #007656;
  }
`;

export const RouterLink = styled(InlineLink).attrs({ as: "span" })``;

export const FooterText = styled.p`
  color: #383839;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 140%;
  margin: 36px 0 0;
  text-align: center;
`;

export const ErrorMessage = styled.p`
  color: #e53935;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 140%;
  margin: 0;
  text-align: center;
`;

export const ForgotPasswordRow = styled.div`
  line-height: 1;
`;
